import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import longMessage from "../../../../../../../../../macros/longMessage.macro";
import useLocale from "assets/scripts/hooks/useLocale";
import styles from "./CapOneDisclaimers.module.less";
/* tslint:disable:max-line-length */
export function CapOneDisclaimers() {
    const locale = useLocale();
    return (<Fragment>
			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.electronicCheckConversion.header" defaultMessage={longMessage `
							Electronic Check Conversion.
						`}/>
				</strong>
				<FormattedMessage id="disclaimer.electronicCheckConversion" defaultMessage={longMessage `
						When you provide a check as payment, you authorize us either to use information from your check to
						make a one-time electronic fund transfer from your deposit account or to process the payment as a
						check transaction. When we use information from your check to make an electronic fund transfer,
						funds may be withdrawn from your deposit account as soon as the same day we receive your payment,
						and you will not receive your check back from your financial institution. Your authorization is not
						limited by the date on the check.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.attemptToCollect" defaultMessage={longMessage `
							This is an attempt to collect this debt and any information obtained will be used for that purpose.
						`}/>
				</strong>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.forDistrictOfColumbia.header" defaultMessage="For District of Columbia residents:"/>
				</strong>
			</p>
			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.forDistrictOfColumbia" defaultMessage={longMessage `
							You might have income or resources that are protected from being taken
							by debt collectors. These might include certain sources of income,
							funds, or property, including, but not limited to, Social Security,
							Supplemental Security Income (SSI), disability or unemployment benefits,
							veteran’s benefits, or child support payments. If you believe your
							property or income may be protected, you may wish to seek legal advice,
							including at a legal services provider or legal aid office, before
							paying this debt.
						`}/>
				</strong>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.forMassachusetts.header" defaultMessage={longMessage `
						For Massachusetts residents:
					`}/>
				</strong><br />
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.forMassachusetts" defaultMessage={longMessage `
						NOTICE OF IMPORTANT RIGHTS: YOU HAVE THE RIGHT TO MAKE A WRITTEN OR ORAL REQUEST THAT TELEPHONE CALLS
						REGARDING YOUR DEBT NOT BE MADE TO YOU AT YOUR PLACE OF EMPLOYMENT. ANY SUCH ORAL REQUEST WILL BE
						VALID FOR ONLY 10 DAYS UNLESS YOU PROVIDE WRITTEN CONFIRMATION OF THE REQUEST POSTMARKED OR DELIVERED
						WITHIN SEVEN DAYS OF SUCH REQUEST. YOU MAY TERMINATE THIS REQUEST BY WRITING TO THE CREDITOR.
					`}/>
				</strong>
			</p>

			{locale !== "es" && <p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.puertoRicoResidents.header" defaultMessage={longMessage `
						Puerto Rico Residents:
					`}/>
				</strong> <FormattedMessage id="disclaimer.puertoRicoResidents" defaultMessage={longMessage `
						You can request a copy of this document in Spanish.
					`}/><br />
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.puertoRicoResidentsSpanish.header" defaultMessage={longMessage `
						Para Residentes de Puerto Rico:
					`}/>
				</strong> <FormattedMessage id="disclaimer.puertoRicoResidentsSpanish" defaultMessage={longMessage `
						Pueden solicitar una copia de este documento en Español.
					`}/>
			</p>}

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.creditReporting.header" defaultMessage={longMessage `
						Credit Reporting of Your Settled Account.
					`}/>
				</strong> <FormattedMessage id="disclaimer.creditReporting" defaultMessage={longMessage `
						If we’re reporting your account to the credit bureaus and you settle your account for less than the full
						balance, we’ll update the account reporting to paid in full for less than the full balance.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.forNewYorkCity.header" defaultMessage={longMessage `For New York City residents whose accounts have charged off:`}/>
				</strong> <FormattedMessage id="disclaimer.forNewYorkCity" defaultMessage={longMessage `
						For our records, New York City law requires us to request your language preference. Please contact us
						at 1-800-258-9319 to advise us about your language preference. If you have already provided your
						language preference to us and would like to change it, please contact us at 1-800-258-9319 to do so.
						Please note that, as permitted by New York City law, we may not service your account in your preferred language.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.bankruptcy.header" defaultMessage={longMessage `Bankruptcy.`}/>
				</strong> <FormattedMessage id="disclaimer.bankruptcy" defaultMessage={longMessage `
						If you are entitled to bankruptcy protections, this communication is only for informational purposes.
						It is not an attempt to collect, assess or recover a debt or claim. Do not send any payments directly
						to us without speaking with your attorney.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.interestAndCharges.header" defaultMessage={longMessage `
						Interest and Charges May Continue to Accrue.
					`}/>
				</strong> <FormattedMessage id="disclaimer.interestAndCharges" defaultMessage={longMessage `
						All stated amounts are owed on the date of this communication. If your account has not charged off,
						and if applicable, your account may be charged interest, late charges and other charges that might
						change from day to day as provided in your agreement. As a result, the amount due on the day you pay
						us may be larger than the amount stated in this communication. For example, if you pay the amount stated
						in this communication, your account might still have a balance after we receive your payment. If your
						account has already charged off, you will not incur any additional interest or fees.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.timePeriodForPayment.header" defaultMessage={longMessage `
						Time Period for Payment or Other Action.
					`}/>
				</strong> <FormattedMessage id="disclaimer.timePeriodForPayment" defaultMessage={longMessage `
						Unless we provide a specific date, any time period for your payment or other action begins on the date of this communication.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.IRSReporting.header" defaultMessage={longMessage `
						IRS Reporting of Debt Forgiveness.
					`}/>
				</strong> <FormattedMessage id="disclaimer.IRSReporting" defaultMessage={longMessage `
						If we cancel or forgive $600 or more of principal on a debt you owe we will provide you a 1099-C tax form,
						if required by law. Please consult your tax advisor and the instructions accompanying any tax forms for more information.
					`}/>
			</p>

			<p>
				<strong className={styles.bold}>
					<FormattedMessage id="disclaimer.whoWeAre.header" defaultMessage={longMessage `Who We Are.`}/>
				</strong> <FormattedMessage id="disclaimer.whoWeAre" defaultMessage="Capital One, N.A."/>
			</p>

			<p>
				<FormattedMessage id="disclaimer.toContactByMail" defaultMessage={longMessage `
						To contact Capital One by mail, please use the following address: Capital One, P.O. Box 30285,
						Salt Lake City, Utah 84130-0285.
					`}/>
			</p>

			<p>
				<FormattedMessage id="disclaimer.creditorHasBeenPreviouslyDisclosed" defaultMessage={longMessage `
						The name of your creditor has been previously disclosed to you and is identified for purposes of
						this communication by your account number.
					`}/>
			</p>

			<p className="vr_x4">
				<FormattedMessage id="disclaimer.pleaseBeAware" defaultMessage={longMessage `
						Please be aware that we provide reasonable accommodations and alternative formats of this communication,
						which can be provided upon request. To make such a request or to learn more about our accommodations,
						please call us at the below number.
					`}/>
			</p>

			<table className={styles.borderedTable}>
				<thead>
					<tr>
						<th colSpan={2} className="tableListRow-list-col">
							<FormattedMessage id="disclaimer.contactUs.header" defaultMessage="Contact Us"/>
						</th>
					</tr>
					<tr>
						<th className="tableListRow-list-col">
							<FormattedMessage id="disclaimer.contactUs.creditCardCollections.header" defaultMessage="Credit Card—Collections"/>
						</th>
						<th className="tableListRow-list-col">
							<FormattedMessage id="disclaimer.contactUs.creditCardChargedOff.header" defaultMessage="Credit Card—Charged Off"/>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="tableListRow-list-col">
							<FormattedMessage id="disclaimer.contactUs.creditCardCollections.number" defaultMessage="1-800-955-6600"/>
							<br />
							<FormattedMessage id="disclaimer.contactUs.creditCardCollections.hours1" defaultMessage="Mon–Fri: 8 a.m.–11 p.m. ET &"/>
							<br />
							<FormattedMessage id="disclaimer.contactUs.creditCardCollections.hours2" defaultMessage="Sat–Sun: 8 a.m.–5 p.m. ET"/>
						</td>
						<td className="tableListRow-list-col">
							<FormattedMessage id="disclaimer.contactUs.creditCardChargedOff.number" defaultMessage="1-800-258-9319"/>
							<br />
							<FormattedMessage id="disclaimer.contactUs.creditCardChargedOff.hours" defaultMessage="Mon–Fri: 8 a.m.–9 p.m. ET"/>
						</td>
					</tr>
				</tbody>
			</table>
		</Fragment>);
}
/* tslint:enable:max-line-length */ 



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/CapOneDisclaimers/CapOneDisclaimers.tsx